import React, { useCallback } from "react";
import { styled, css } from "styled-components";
import { Badge } from "components/bootstrap";
import Routes from "routing/Routes";
import { Link } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useLocation from "routing/useLocation";
import { getPathnameWithoutId } from "util/URLUtils";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const RetrievedStatusBadge = styled(Badge)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xxs};
  `
);
const INTERNAL_DATA_LAKE_LABEL = "Internal Data Lake";
const StreamTitleCell = ({ streamId, streamTitle }) => {
  const sendTelemetry = useSendTelemetry();
  const { pathname } = useLocation();
  const handleClick = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.RETRIEVALS.SHOW_MESSAGES_BUTTON_CLICKED, {
      app_pathname: getPathnameWithoutId(pathname)
    });
  }, [pathname, sendTelemetry]);
  return /* @__PURE__ */ React.createElement(Link, { to: `${Routes.stream_view(streamId)}?segment=destinations`, onClick: handleClick }, streamTitle);
};
const customColumnRenderers = {
  attributes: {
    status: {
      renderCell: (status) => /* @__PURE__ */ React.createElement(RetrievedStatusBadge, { bsStyle: status === "COMPLETE" ? "success" : "warning" }, status),
      staticWidth: 130
    },
    source_name: {
      renderCell: (source_name, entity) => entity.type === "ICEBERG" ? INTERNAL_DATA_LAKE_LABEL : source_name
    },
    stream_title: {
      renderCell: (stream_title, entity) => /* @__PURE__ */ React.createElement(StreamTitleCell, { streamId: entity.stream_id, streamTitle: stream_title })
    },
    restore_indices: {
      renderCell: (restore_indices) => /* @__PURE__ */ React.createElement(React.Fragment, null, restore_indices.length),
      staticWidth: "matchHeader"
    },
    retrieved_documents: {
      staticWidth: "matchHeader"
    },
    index_failures: {
      staticWidth: "matchHeader"
    },
    type: {
      staticWidth: "matchHeader"
    }
  }
};
export default customColumnRenderers;
